export default "__VITE_ASSET__BZDRw5HP__";